// extracted by mini-css-extract-plugin
export default {"title":"Map_title__THUez","label":"Map_label__vnfRH"};